import React from 'react';
import { Box, Container } from '@mui/material';
import Image from 'src/components/Image';
import Hero from './components/hero';
import Customers from './components/customers';
import Team from './components/team';
import LandingHero from './components/LandingHero';
import AboutSection from './components/AboutSection';
import HowWeWork from './components/HowWeWork';
import ServicesSection from './components/ServicesSection';
import TestimonialsNew from './components/TestimonialsNew';

const Home = () => (
  <>
    <Box sx={{ position: 'relative' }}>
      <LandingHero />
      <Container
        maxWidth="xl"
        sx={{
          left: 0,
          right: 0,
          bottom: 0,
          position: { xs: 'absolute', md: 'absolute' },
          mx: 'auto',
        }}
      >
        <Customers />
      </Container>
      
    </Box>

    <Box
      sx={{
        backgroundImage: {
          md: "url('https://www.prisma.io/illustrations/home-page/hero-lines-mobile.svg')",
        },
        backgroundRepeat: 'round',
        width: '100%',
        height: '100%',
      }}
    >
      <TestimonialsNew />
    </Box>

    <Hero />
    <AboutSection />
    <HowWeWork />
    <ServicesSection />
    <Team />
  </>
);

export default Home;
